import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { signInWithPopup } from 'firebase/auth';
import { auth, provider } from '../sign_in/Firebase';

export default function Login({ setIsLoggedIn }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(true);

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: username,
          password: password
        })
      });

      const result = await response.json();

      if (result.success) {
        localStorage.setItem('token', result.token);
        localStorage.setItem('username', username);
        setIsLoggedIn(true);
        navigate('/Profile');
      } else {
        alert(result.message || 'Login failed.');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('Something went wrong. Try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const response = await fetch(`${API_BASE_URL}/auth/google-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: user.email,
          uid: user.uid
        })
      });

      const loginResult = await response.json();

      if (loginResult.success) {
        localStorage.setItem('token', loginResult.token);
        localStorage.setItem('username', user.email);
        setIsLoggedIn(true);
        navigate('/Profile', { state: { email: user.email } });
      } else {
        alert(loginResult.message || 'Google login failed.');
      }
    } catch (error) {
      console.error('Google Sign-In error:', error);
      alert('Something went wrong with Google Sign-In.');
    } finally {
      setIsLoading(false);
    }
  };

  return showLogin ? (
    <div className="login-page">
      <div className="login-box">
        <button className="close-button" onClick={() => setShowLogin(false)}>
          &times;
        </button>
        <h2 className="login">Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Email</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="submit-button" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Submit'}
          </button>

          <button
            type="button"
            onClick={handleGoogleLogin}
            className="google-button"
            disabled={isLoading}
          >
            <img
              src="/Google_Icon.png"
              alt="Google logo"
              style={{ width: '20px', marginRight: '8px', verticalAlign: 'middle' }}
            />
            {isLoading ? 'Signing in with Google...' : 'Sign in with Google'}
          </button>
        </form>
      </div>
    </div>
  ) : null;
}
